import React from 'react'
// import { useDispatch, useSelector } from 'react-redux'
// import moment from 'moment'
import { History } from 'history'
import classNames from 'classnames'

import Button from './button'
import { InnerBox, OuterBox } from './two-columns'
import styles from '../component-styles/campaign-code-generator-module-clone-tab.module.scss'

interface Props {
  history: History
}

export default function CampaignCodeGeneratorCloneTab({
  history,
}: Props): React.ReactElement {
  return (
    <OuterBox className={styles.outerBox}>
      <InnerBox className={classNames(styles.innerBox, styles.innerBoxContent)}>
        <p>
          Rather than creating links from scratch, you can clone existing links
          and edit the parameters to make new links quickly.
        </p>
        <h2>How to create campaign links using clone and edit:</h2>
        <ol>
          <li>
            In the left-hand navigation bar, click{' '}
            <span className={styles.boxed}>Track&gt;View</span>
          </li>
          <li>
            In the left-hand column of the table, tick the box next to the
            link(s) you want to clone
          </li>
          <li>
            Click on the pink <span className={styles.boxed}>Action</span>{' '}
            button and select{' '}
            <span className={styles.boxed}>Clone and edit</span>
          </li>
          <li>
            You will be taken to the{' '}
            <span className={styles.boxed}>Track&gt;Create</span> page with the
            parameters pre-selected
          </li>
          <li>Edit the parameters you want to change</li>
          <li>
            <span className={styles.optional}>(Multiple only)</span> Review the
            campaign link combinations you want
          </li>
          <li>
            Click <span className={styles.boxed}>Create campaign link(s)</span>{' '}
            button to create your campaign link(s)
          </li>
        </ol>
        <Button
          align="right"
          style={{ margin: '8px 0 0 0' }}
          className={`${styles.addButton}`}
          type="flatPink"
          onClick={() => {
            history.push(`/track/view-campaign-codes`)
          }}
        >
          View existing links
        </Button>
        <br />
        <br />
        <img
          alt="Clone &amp; Edit single codes"
          src="/clone-edit-multiple.gif"
        />
      </InnerBox>
    </OuterBox>
  )
}
